import {
  CardLoading,
  CardNotice,
  ChatCard,
} from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { ChartColumn } from 'lucide-react-native';
import { memo } from 'react';
import { BiDraftState } from './functions/useBiDraft';

/** A draft's state while it has no chart to show. */
export type BiDraftPendingState = Exclude<BiDraftState, { kind: 'ready' }>;

/** What a card without a draft says in its body. */
function pendingNotice(state: BiDraftPendingState) {
  switch (state.kind) {
    case 'loading':
      return <CardLoading label="正在读取数据…" />;
    case 'expired':
      return <CardNotice text={state.message} />;
    case 'missing':
      return <CardNotice text="这张图表已不可用，请重新提问生成。" />;
    case 'failed':
      return <CardNotice tone="danger" text="图表没有加载出来，请稍后重试。" />;
  }
}

/** The chat's chart card before (or instead of) its draft. */
export const BiDraftPendingCard = memo(
  ({ state, title }: { state: BiDraftPendingState; title: string }) => (
    <ChatCard icon={ChartColumn} color={aiColors.amber} title={title}>
      {pendingNotice(state)}
    </ChatCard>
  ),
);
